import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, concatMap, map, withLatestFrom } from 'rxjs/operators';
import { TextTemplatesEntity, TextTemplatesEntityFromBackend } from '../../entities/text-templates.entity';
import { HttpService } from '../../services/http.service';
import { BaseActionTypes } from '../actions/base.actions';
import { TextTemplatesActionTypes } from '../actions/textTemplates.actions';
import { State } from '../index';
import { getToken } from '../selectors/base.selectors';

enum ErrorCodes {
    Load = 'TextTemplates Abrufen fehlgeschlagen',
    Modify = 'TextTemplates Bearbeiten fehlgeschlagen',
    Remove = 'TextTemplates Löschen fehlgeschlagen',
    Add = 'TextTemplates Hinzufügen fehlgeschlagen',
}

@Injectable()
export class TextTemplatesEffects {

    GetTextTemplates$ = createEffect(() => this.actions$.pipe(
        ofType(TextTemplatesActionTypes.Load),
        withLatestFrom(this.store$.select(getToken)),
        concatMap(([action, token]) => {
            const queryString = `
            query {
                textTemplates {
                    ${TextTemplatesEntity.GqlFields}
                }
            }`;

            return this.gatewayHttpService.graphQl({ query: queryString }, { token, retry: true }).pipe(
                map(res => {
                    return res && res.textTemplates
                        ? TextTemplatesActionTypes.UpdateAll({
                              Payload: (res.textTemplates || []).map(e => TextTemplatesEntityFromBackend(e)),
                          })
                        : BaseActionTypes.ErrorAction({ Payload: { ToasterMessage: ErrorCodes.Load } });
                }),
                catchError((err, caught) =>
                    of(
                        BaseActionTypes.ErrorAction({
                            Payload: {
                                ToasterMessage: ErrorCodes.Load,
                                Err: err,
                                Caught: caught,
                            },
                        }),
                    ),
                ),
            );
        }),
    ));
    constructor(private actions$: Actions, private store$: Store<State>, private gatewayHttpService: HttpService) {}
}
